import { Payload, Types } from 'states/dux/theme/types'
import { Action } from 'states/types'
import { getSavedTheme } from 'utils/common'

const initialState: Payload = getSavedTheme()

const reducer = (state = initialState, action: Action<Payload>): Payload => {
  const { type, payload } = action
  switch (type) {
    case Types.SET: {
      localStorage.setItem('nivos_theme', JSON.stringify(payload))
      return payload
    }
    default:
      return state
  }
}

export { reducer }

export default reducer
